import React, { useEffect, useState, useRef } from "react";

import DropdownCommon, { DropdownCommonProps } from "./DropdownCommon";

export type DropdownWithoutFormProps = Omit<DropdownCommonProps, "value" | "hasError"> & {
  value?: any;
  defaultValue?: string | number;
};

function DropdownWithoutForm(props: DropdownWithoutFormProps) {
  const { defaultValue, value, onChange } = props;
  const [selected, setSelected] = useState(defaultValue || value);
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    setSelected(value);
  }, [value]);

  return (
    <DropdownCommon
      {...props}
      value={selected}
      onChange={(val: any) => {
        setSelected(val?.value);
        if (onChange) {
          onChange(val);
        }
      }}
    />
  );
}

export default DropdownWithoutForm;

DropdownWithoutForm.defaultProps = {
  value: "",
  defaultValue: "",
};
